import React from 'react';
import { MenuItem, Stack, Typography } from '@mui/material';
import { PlanOption } from './utils';
import styles from './PlanMenuItem.module.scss';

/**
 * Shared two-line plan option, used by every plan picker (Create Org, the org-listing
 * plan filter, Plan & Limits' tier switcher) so they render identically. The subtitle
 * disambiguates tiers that share a display name — several real tiers do (e.g. multiple
 * "Free"/"Trial" tiers with different limits/ids).
 *
 * Deliberately a plain function returning a MenuItem directly (`renderItem={renderPlanMenuItem}`),
 * not a wrapper component rendered as `<PlanMenuItem />`. MUI's Select reads value/onClick/
 * selected off its DIRECT child's element without ever rendering nested components — a
 * wrapper component would need to perfectly forward every prop MUI injects, and missing
 * even one (as happened here) silently breaks selection instead of erroring.
 */
export function renderPlanMenuItem(item: PlanOption) {
  return (
    <MenuItem key={item.value} value={item.value} className={styles.planMenuItem}>
      <Stack>
        <Typography variant="body2" fontWeight={600}>
          {item.title}
        </Typography>
        {item.subtitle && (
          <Typography variant="body3" color="text.secondary">
            {item.subtitle}
          </Typography>
        )}
      </Stack>
    </MenuItem>
  );
}
